import { computed, Injectable, signal } from '@angular/core';

import type { AuthState, SessionPayload } from './auth.models';

@Injectable({ providedIn: 'root' })
export class AuthStore {
  private readonly state = signal<AuthState>({
    status: 'loading',
    user: null,
    actor: null
  });

  readonly status = computed(() => this.state().status);
  readonly user = computed(() => this.state().user);
  readonly actor = computed(() => this.state().actor);
  readonly isAuthenticated = computed(() => this.state().status === 'authenticated');
  readonly activeStoreId = computed(() => this.state().actor?.activeStoreId ?? this.state().user?.activeStoreId ?? null);
  readonly storeMemberships = computed(() => this.state().actor?.storeMemberships ?? this.state().user?.storeMemberships ?? []);

  setLoading(): void {
    this.state.update((current) => ({ ...current, status: 'loading' }));
  }

  setAuthenticated(payload: SessionPayload): void {
    this.state.set({
      status: 'authenticated',
      user: payload.user,
      actor: payload.actor
    });
  }

  setUnauthenticated(): void {
    this.state.set({
      status: 'unauthenticated',
      user: null,
      actor: null
    });
  }
}
